module.exports = __webpack_public_path__ + "static/media/google12.9fcfa2a6.png";